module.exports = {
	account: ['account/*'],
	'credit-card': ['credit-card/*'],
	checkout: ['checkout/*'],
	product: ['product/*'],
}
